import View from "./view";
import React from "react";

export default function Artist() {
  return <View />;
}



// WEBPACK FOOTER //
// ./src/pages/Artist/index.jsx